export const verify = {
  invalid_or_expired_token:
    "Ogiltig eller utgången länk. Vänligen begär en ny lösenordsåterställning.",
  title: "Aktivera konto",
  missing_link: "Aktiveringslänk saknas eller är ogiltig.",
  go_to_login: "Gå till inloggning",
  email: "E-post",
  first_name: "Förnamn",
  last_name: "Efternamn",
  nickname: "Smeknamn",
  new_password: "Nytt lösenord",
  confirm_password: "Bekräfta lösenord",
  date_of_birth: "Födelsedatum",
  gender: "Kön",
  gender_male: "Man",
  gender_female: "Kvinna",
  gender_not_share: "Vill ej ange",
  activate: "Aktivera",
  activating: "Aktiverar...",
  activated: "Konto aktiverat. Nu kan du logga in i mobilappen!",
  all_fields_required: "Alla obligatoriska fält måste fyllas i",
  passwords_do_not_match: "Lösenorden matchar inte",
  error: "Aktivering misslyckades",
};
